import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import { ui } from "../../../../../../../interfaces/interfaces";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { bookingBillingValid, getFailedReasons } from "@utils/general";
import { useAppSelector } from "@store/hooks";
import { RightioWBSAPIModelsFailedReasons } from "@utils/apis/wbs/endpoints";

const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
  ui.BookingPaymentIsBooked = checked
};

const handleOptionChange = (event: React.SyntheticEvent<Element, Event>, value: RightioWBSAPIModelsFailedReasons | null) => {
  ui.BookingRejectionReason = value
};

type Props = {}

const BookingSwitches: React.FC<Props> = () => {
  const bookingPaymentIsBooked = useAppSelector(({ ui }) => ui.BookingPaymentIsBooked)
  const bookingRejectionReason = useAppSelector(({ ui }) => ui.BookingRejectionReason)

  React.useEffect(() => {
    bookingBillingValid()
  }, [bookingRejectionReason])

  return (
    (<Paper elevation={4} sx={(theme) => ({
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
      [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
      },
      '& input': { height: 10 },
    })} >
      <Grid container spacing={1} style={{ alignItems: "center" }}>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <FormGroup row style={{ margin: 0, padding: 0 }}>
            <FormControlLabel
              control={<Switch checked={bookingPaymentIsBooked} onChange={handleChange} name={`BookingPaymentIsBooked`} color="primary" />}
              label="Booked?"
              style={{ marginBottom: 0 }}
            />
          </FormGroup>
        </Grid>
        {!bookingPaymentIsBooked && <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={getFailedReasons() || []}
            getOptionLabel={(option) => option.failedReason}
            value={bookingRejectionReason}
            onChange={handleOptionChange}
            sx={{ width: 250 }}
            renderInput={(params) => <TextField {...params} label="Rejection reason" sx={{ '& > div > input': { padding: "7.5px 4px 7.5px 6px !important" } }} />}
          />
        </Grid>}
      </Grid>
    </Paper >)
  );
}

export default BookingSwitches